import { toast } from 'react-toastify';

export function showSuccessToaster(msg: string) {
  toast.success(msg, {
    autoClose: 3000,
  });
}

export function showErrorToaster(msg: string) {
  toast.error(msg);
}

export function showWarnToaster(msg: string) {
  toast.warn(msg, {
    className: 'custom-toast',
    position: toast.POSITION.TOP_CENTER,
  });
}

export function showInfoToaster(msg: string) {
  toast.warn(msg, {
    autoClose: 5000,
  });
}

export function showGreenInfo10Toaster(msg: string) {
  toast.success(msg, {
    autoClose: 10000,
    className: 'custom-toast-w700',
    position: toast.POSITION.TOP_CENTER,
  });
}
